import Request from 'src/utils/request'

/**
 * 查询系统信息
 */
export function getSystemInfoApi () {
  return Request({
    url: '/system/info',
  })
}

/**
 * 更新系统信息
 */
export function updateSystemInfoApi (data) {
  return Request({
    url: '/system/update_setting',
    method: 'post',
    data,
  })
}
